export const MANUAL_ACCOUNT_FIELDS = {
  ACCOUNT_TYPE: "accountType",
  ACCOUNT_SUB_TYPE: "accountSubType",
  ACCOUNT_NAME: "accountName",
  ACCOUNT_BALANCE: "accountBalance",
};
